import { SharingDraft } from '@/types';
import { getRequest } from './methods/getRequest';
import { requestToJSON } from './methods/requestToJSON';

export const fetchDraft = (draftId: string) =>
  requestToJSON<SharingDraft>(getRequest(`/api/drafts/${draftId}/`));
